/**
 *
 * @param {*} fn
 * @param {*} t
 * @returns
 */
export function debounce(fn,t){
    let timer
    return function(...args){
        if(timer) clearTimeout(timer);
        timer =setTimeout(()=>{
          fn.apply(this,args)
        },t)
    }
}

